<!-- eslint-disable unused-imports/no-unused-vars -->
<!-- eslint-disable vue/no-unused-refs -->
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useGalleriesStore, useSettingStore } from 'pinia-store'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import type { ILabels } from '@ui/interfaces/labels'
import type { IProfileParams } from '@ui/interfaces/hotel'
import { toQueryUrl } from '@ui/composables'
import ModalGallery from '@ui/base-components/modal/Gallery'

import 'swiper/css'

const props = defineProps<{
  labels: ILabels
  profile: IProfileParams
}>()

const useGalleries = useGalleriesStore()
const loading = computed(() => useGalleries.loading)
const galleries = computed(() => useGalleries.list)
const useSetting = useSettingStore()
const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smallerOrEqual('sm')
const swipers = ref({})
const thumbsSwiper = ref({})
const modal = ref(false)
const detail = ref({
  el: {},
  index: -1,
  open: false,
})

function onSwiper(el) {
  if (el && typeof el === 'object') {
    swipers.value = el
    detail.value.el = el
    thumbsSwiper.value = el
  }
}

async function handleShowDialog(index) {
  detail.value.open = true
  detail.value.index = index

  modal.value = true
}
</script>

<template>
  <!-- Start block -->
  <section id="section-photos" class="section-gallery">
    <div class="section-home-photo-bottom margin_120_0">
      <div class="row home justify-center">
        <ClientOnly
          fallback-tag="span"
          fallback="Loading..."
        >
          <Swiper
            :autoplay="{
              delay: 5000,
              disableOnInteraction: false,
            }"
            :loop="galleries.length > 3"
            :breakpoints="{
              320: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 3,
              },
              1400: {
                slidesPerView: 4,
              },
            }"
            :space-between="0"
            :modules="[Autoplay]"
            class="swiper-gallery"
            @swiper="e => onSwiper(e)"
          >
            <SwiperSlide v-for="(gallery, index) in galleries" :key="index" class="item col-lg-5 col-xl-3 p-0">
              <div v-if="gallery?.gallery_image" class="box_contents m-0 rounded-0 p-0">
                <figure class="relative cursor-pointer" @click="handleShowDialog(index)">
                  <VueImg
                    :src="
                      toQueryUrl(gallery?.gallery_image, {
                        d: '665x665',
                      })
                    "
                    :alt="gallery?.gallery_groups || 'Groups'"
                    :height="665"
                    :width="665"
                    class="img-fluid img-100 object-cover"
                  />
                </figure>
              </div>
            </SwiperSlide>
          </Swiper>
        </ClientOnly>
      </div>
      <!-- /row -->
    </div>
  </section>
  <!-- End block -->

  <!-- GALLERY DIALOG -->
  <ModalGallery
    v-model:show="modal"
    v-model:thumbs-swiper="thumbsSwiper"
    v-model="detail"
    :loading="loading"
    :profile="props?.profile"
    :galleries="galleries"
  />
</template>
